import React from 'react';
import { TbBattery3 } from 'react-icons/tb';

import { EnergyCapacity, energyConverter } from 'models';

import { MeasurementInput } from 'components/forms/fields/measurement/MeasurementInput';
import type { MeasurementInputWrapperProps } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { MeasurementInputWrapper } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { UnitWithTooltip } from 'components/forms/fields/measurement/Unit';
import { useMultiUnitMeasurementController } from 'components/forms/fields/measurement/useMultiUnitMeasurementController';

type CapacityFieldProps = { name: string; hideIcons?: boolean } & MeasurementInputWrapperProps;

const CapacityField = ({ name, hideIcons, ...wrapperProps }: CapacityFieldProps) => {
    const {
        unit,
        cycleUnit,
        fields: { value },
    } = useMultiUnitMeasurementController({
        name,
        converter: energyConverter,
        fields: ['value'],
        defaultUnit: EnergyCapacity.defaultViewUnit,
    });

    return (
        <MeasurementInputWrapper {...wrapperProps}>
            <MeasurementInput
                {...value}
                icon={hideIcons ? null : <TbBattery3 size={20} strokeWidth={1.25} />}
                unit={<UnitWithTooltip onClick={cycleUnit}>{unit}</UnitWithTooltip>}
            />
        </MeasurementInputWrapper>
    );
};

export { CapacityField };
